/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Table_SectionInputs */

const en_users_table_section = /** @type {(inputs: Users_Table_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All users`)
};

const pt_br2_users_table_section = /** @type {(inputs: Users_Table_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os usuários`)
};

/**
* | output |
* | --- |
* | "All users" |
*
* @param {Users_Table_SectionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_table_section = /** @type {((inputs?: Users_Table_SectionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Table_SectionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_table_section(inputs)
	return pt_br2_users_table_section(inputs)
});